import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getFactoryById } from '../data/factories';
import MediaList from '../components/FileUpload/MediaList';
import { getMediaFiles } from '../services/storage';
import { MediaFile } from '../types/media';

const FactoryPage: React.FC = () => {
  const { factoryId } = useParams<{ factoryId: string }>();
  const navigate = useNavigate();
  
  const [files, setFiles] = useState<MediaFile[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const factory = getFactoryById(factoryId || '');
  
  // Fetch media files for the factory
  const loadMediaFiles = async () => {
    if (!factoryId) return;
    
    setIsLoading(true);
    try {
      const mediaFiles = await getMediaFiles(factoryId);
      setFiles(mediaFiles);
    } catch (error) {
      console.error('Error loading media files:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    if (!factory) {
      navigate('/');
      return;
    }
    
    loadMediaFiles();
  }, [factoryId, factory, navigate]);

  return (
    <div className="animate-fade-in">
      <div className="flex items-center mb-6">
        <button 
          onClick={() => navigate('/')}
          className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 mr-2"
          aria-label="Retour"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700 dark:text-gray-200" />
        </button>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {factory?.name}
        </h1>
      </div>
      
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden">
        <div className="h-12 bg-primary flex items-center px-4">
          <h2 className="text-base font-medium text-white">
            Fichiers disponibles
          </h2>
        </div>
        
        <div className="p-4">
          <MediaList 
            files={files} 
            isLoading={isLoading} 
            onDelete={loadMediaFiles}
          />
        </div>
      </div>
    </div>
  );
};

export default FactoryPage